const cache = new Map<string, number>();

let context: CanvasRenderingContext2D | null | undefined;

function measurer(): CanvasRenderingContext2D | null {
  if (context !== undefined) return context;
  if (typeof document === 'undefined') {
    context = null;
    return context;
  }
  context = document.createElement('canvas').getContext('2d');
  if (context !== null) {
    const family = getComputedStyle(document.documentElement).getPropertyValue('--wis-font');
    context.font = `100px ${family.trim() === '' ? 'sans-serif' : family}`;
  }
  return context;
}

export function widestRatio(texts: readonly string[], fallback: number): number {
  const ctx = measurer();
  if (ctx === null) return fallback;
  let widest = 0;
  for (const text of texts) {
    let ratio = cache.get(text);
    if (ratio === undefined) {
      ratio = ctx.measureText(text).width / 100;
      cache.set(text, ratio);
    }
    widest = Math.max(widest, ratio);
  }
  return widest > 0 ? widest : fallback;
}

export function forgetMeasurements(): void {
  cache.clear();
}
